<template>
    <div class="container">
        <h1>Configure Objects</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="List">
                <app-object-list :list="objectList"></app-object-list>
            </b-tab-item>
            <b-tab-item label="Add Object">
                <div class="container has-text-left">
                    <b-field label="Name">
                        <b-input v-model="objectName" required placeholder="OBJECT NAME"></b-input>
                    </b-field>
                    <b-field label="Type">
                        <b-select placeholder="Select a type..." v-model="objectTypeId">
                            <option v-for="objectType in availableObjectTypes" v-bind:key="objectType.id" :value="objectType.id">{{objectType.name}}</option>
                        </b-select>
                    </b-field>
                    <b-field label="Value suffix" v-if="objectTypeId > 0">
                        <b-input v-model="objectSuffix" placeholder="Suffix for the value (optional)..."></b-input>
                    </b-field>
                    <b-field>
                        <b-button type="is-success" @click="handleClickAddObject" :disabled="!validFields()">Add Object</b-button>
                    </b-field>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import ObjectList from '../components/configure/ObjectList';
    import BTabItem from "buefy/src/components/tabs/TabItem";
    import BField from "buefy/src/components/field/Field";
    import BInput from "buefy/src/components/input/Input";
    import BButton from "buefy/src/components/button/Button";

  export default {
    name: "screenconfigureobjects",
    components: {
      BButton,
      BInput,
      BField,
      BTabItem,
      appObjectList: ObjectList
    },
    data() {
      return {
        activeTab: 0,
        objectName: '',
        objectTypeId: 0,
        objectRoomId: 0,
        objectList: [],
        objectSuffix: ''
      };
    },
    watch: {
      serialized: {
        immediate: true,
        handler() {
          const arr = [];
          Object.keys(this.objects).forEach(id => {
            const obj = this.objects[id];
            arr.push(obj);
          });
          this.objectList = arr;
        }
      }
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('auth', ['hasPermission']),
      ...mapGetters('objects', ['objects', 'objectTypes', 'serialized']),
      ...mapGetters('rooms', ['rooms']),
      availableRooms() {
        const arr = [
          {id: 0, name: '- none -'}
        ];

        if (this.rooms) {
          this.rooms.forEach(room => {
            arr.push(room);
          });
        }

        return arr;
      },
      availableObjectTypes() {
        const arr = [
          {id: 0, name: 'Select object type...'}
        ];

        if (this.objectTypes) {
          this.objectTypes.forEach(item => {
            arr.push(item);
          });
        }

        return arr;
      }
    },
    methods: {
      ...mapActions('objects', ['createObject']),
      hasConfigurePermission(permissionId) {
        return this.hasPermission(permissionId);
      },
      handleClickAddObject() {
        this.createObject({
          name: this.objectName,
          typeId: parseInt(this.objectTypeId),
          roomId: parseInt(this.objectRoomId),
          suffix: this.objectSuffix.trim(),
          graphTemplateId: 2
        });
        this.activeTab = 0;
      },
      validFields() {
        if (this.objectName.length < 1) {
          return false;
        }

        if (this.objectTypeId === 0) {
          return false;
        }

        return true;
      }
    }
  }
</script>

<style scoped>
h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}

    .container {
        margin-top: 1rem;
    }
</style>